/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { StyleSheet } from 'react-native-unistyles';

import { pd } from '@airasia-phoenix/react-native/tokens';
import { getColor } from '@airasia-phoenix/react-native/utils/utils';

const styles = StyleSheet.create((pd) => ({
  footerContainer: {
    alignItems: 'center',
    backgroundColor: getColor(pd.sys.colour.container_low),
    paddingVertical: pd.ref.space.spacing80.px,
    paddingHorizontal: {
      xs: 16,
      sm: '7%',
      md: 48,
      lg: 80,
      xl: '12%',
      superLarge: '7%',
    },
  },
  footer: {
    width: '100%',
    alignSelf: 'center',
  },
  footerMainContent: {
    display: 'flex',
    flexDirection: {
      xl: 'row',
      xs: 'column',
    },
    justifyContent: {
      xl: 'space-between',
      xs: 'flex-start',
    },
    gap: {
      xl: pd.ref.space.spacing80.px,
      xs: 0,
    },
    marginTop: {
      lg: pd.ref.space.spacing60.px,
      sm: pd.ref.space.spacing40.px,
      xs: pd.ref.space.spacing30.px,
    },
  },
  divider: {
    marginVertical: {
      md: pd.ref.space.spacing60.px,
      sm: pd.ref.space.spacing40.px,
      xs: pd.ref.space.spacing30.px,
    },
  },
  sectionsContainer: {
    flexDirection: 'row',
    width: '100%',
    flex: 1,
    flexWrap: 'wrap',
  },
  section: {
    flexGrow: 1,
    paddingBottom: {
      xs: 20,
      sm: 20,
      lg: 0,
    },
    width: {
      xs: '100%',
      sm: '50%',
      lg: '25%',
    },
  },
  sectionTitle: {
    marginBottom: pd.ref.space.spacing30.px,
  },
  link: {
    lineHeight: 28,
  },
  actionContainer: {
    flexDirection: {
      xl: 'column',
      md: 'row',
      xs: 'column',
    },
    width: {
      xl: 350,
      xs: '100%',
    },
    justifyContent: {
      xl: 'flex-start',
      md: 'space-between',
      xs: 'flex-start',
    },
    gap: {
      md: pd.ref.space.spacing60.px,
      xs: pd.ref.space.spacing30.px,
    },
  },
  actionDivider: {
    display: {
      xl: 'none',
      xs: 'flex',
    },
  },
  tertiaryText: {
    lineHeight: pd.sys.typescale.caption_text.line_height,
  },
}));
export default styles;
